(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CampusDetailController', CampusDetailController);

    CampusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Campus'];

    function CampusDetailController($scope, $rootScope, $stateParams, previousState, entity, Campus) {
        var vm = this;

        vm.campus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:campusUpdate', function(event, result) {
            vm.campus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
